import React, { useState, useEffect } from "react";
import moment from "moment";
import SubMenu from "../Menu/SubMenu";
import { NavLink, Switch, Route, Redirect, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getOffers,
  changeStatus,
  removeOffer,
} from "../../../store/actions/dashboard/offers";
import welcomeOffers from "../../../assets/welcome/offers.svg";
import Loader from "../UI/Loader";

import FindRoundtrips from './FindRoundtrips';
import Roundtrips from "./Roundtrips";
import UserNotice from "../../UserNotice/UserNotice";
import SubscribeGateway from "../../Modals/AuthGatewayModals/SubscribeGateway";
import ProGateway from "../../Modals/AuthGatewayModals/ProGateway";
import LeftDrawer from "../Drawers/LeftDrawer";
import Navbar from "../Navbar";
import Screen from "../Screen/Screen";
import ScreenBlock from "../Screen/ScreenBlock";
import { isBrowser } from "react-device-detect";
import Minimessages from "../Messages/Minimessages";
import DashboardFooter from "../DashboardFooter";

const MyOffersWrapper = (props) => {
  const [redirectUrl, setRedirectUrl] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [isRegular, setIsRegular] = useState(false);
  const [expiredModal, setExpiredModal] = useState(false);
  const [regularModal, setRegularModal] = useState(false);
  const [isActivationModal, setIsActivationModal] = useState(false);
  const OFFERS = useSelector((state) => state.dashboard.offers?.data);
  const USER_PLAN = useSelector(
    (state) => state.dashboard.company?.data?.activeSubscription
  );
  const SUBSCRIPTION_NAME = useSelector(
    (state) => state.dashboard.company?.data?.subscriptionPlan?.subscriptionName
  );
  const dispatch = useDispatch();

  // Set first route to either roundtrips or find-roundtrip
  useEffect(() => {
    const isOffersPage =
      props.location?.pathname === "/dashboard/my-offers" ||
      props.location?.pathname === "/dashboard/my-offers/";
    if (isOffersPage && OFFERS && OFFERS[1]?.roundtrips?.length > 0) {
      setRedirect(true);
      setRedirectUrl("/dashboard/my-offers/roundtrips");
      return;
    }
    if (isOffersPage && OFFERS && OFFERS[4]?.findRoundtrips?.length > 0) {
      setRedirect(true);
      setRedirectUrl("/dashboard/my-offers/find-roundtrip");
      return;
    }
  }, [props.location?.pathname, OFFERS]);

  // Fetch current offers
  useEffect(() => {
    if (!OFFERS) {
      dispatch(getOffers());
    }
  }, [OFFERS, dispatch]);

  // Set subscription barrier
  /*   useEffect(() => {
    if (typeof USER_PLAN !== 'undefined' && !USER_PLAN) setIsExpired(true);
  }, [USER_PLAN]); */

  useEffect(() => {
    if (
      (SUBSCRIPTION_NAME !== "undefined" &&
        SUBSCRIPTION_NAME !== "Roundtrip Pro") ||
      (typeof USER_PLAN !== "undefined" && !USER_PLAN)
    ) {
      setIsRegular(true);
    }
  }, [SUBSCRIPTION_NAME, USER_PLAN]);

  // Change handler for changing the status of an offer
  const handleStatusChange = (id, newStatus, type, array) => {
    dispatch(changeStatus(id, newStatus, type, array))
      .catch((error) => {
        // Handle different types of errors
        if (error?.response?.status === 403) {
          const errorMessage = error?.response?.data?.error || '';
          
          // Check if it's a subscription-related error
          if (errorMessage.includes('Roundtrip Pro subscription required') ||
              errorMessage.includes('subscription') ||
              errorMessage.includes('expired') ||
              errorMessage.includes('subscription period')) {
            
            // Set flag that this was triggered by activation attempt
            setIsActivationModal(true);
            
            // Show the appropriate modal based on user's subscription status
            if (SUBSCRIPTION_NAME === 'undefined' || !SUBSCRIPTION_NAME || SUBSCRIPTION_NAME !== 'Roundtrip Pro') {
              setRegularModal(true); // Show upgrade modal
            } else {
              setExpiredModal(true); // Show subscription expired modal
            }
          }
        }
        // You could add a toast notification here for other types of errors
        console.error('Error changing offer status:', error);
      });
  };

  // Delete handler for deleting an offer
  const handleOfferRemove = (id, array) => dispatch(removeOffer(id, array));

  return (
    <>
      <Screen>
        <Navbar />
        {/* Display Welcome mat when no roundtrips or find-roundtrips: else show menu */}
        {OFFERS &&
        OFFERS[1]?.roundtrips &&
        OFFERS[1]?.roundtrips?.length <= 0 &&
        OFFERS[4]?.findRoundtrips &&
        OFFERS[4]?.findRoundtrips?.length <= 0 ? (
          <ScreenBlock>
            <UserNotice
              image={welcomeOffers}
              title="Start by adding your first roundtrip or roundtrip request"
              isExpired={isExpired}
              buttons={[
                {
                  name: "Add roundtrip",
                  isRouter: true,
                  isRegular: isRegular,
                  to: "/dashboard/roundtrip/create",
                },
                {
                  name: "Add roundtrip request",
                  isRouter: true,
                  isRegular: isRegular,
                  to: "/dashboard/find-roundtrip/create",
                },
              ]}
            />
          </ScreenBlock>
        ) : OFFERS ? (
          <>
            {redirect && <Redirect to={redirectUrl} />}
            <SubMenu>
              {OFFERS &&
              OFFERS[1]?.roundtrips &&
              OFFERS[1]?.roundtrips?.length > 0 ? (
                <NavLink
                  activeClassName="active"
                  to="/dashboard/my-offers/roundtrips"
                >
                  Roundtrips ({OFFERS[1]?.roundtrips?.length})
                </NavLink>
              ) : (
                <>
                  {!isRegular ? (
                    <Link to="/dashboard/roundtrip/create">Add roundtrip</Link>
                  ) : (
                    <button type="button" onClick={() => setRegularModal(true)}>
                      Add roundtrip
                    </button>
                  )}
                </>
              )}
              {OFFERS &&
              OFFERS[4]?.findRoundtrips &&
              OFFERS[4]?.findRoundtrips?.length > 0 ? (
                <NavLink
                  activeClassName="active"
                  to="/dashboard/my-offers/find-roundtrip"
                >
                  Roundtrip Requests ({OFFERS[4]?.findRoundtrips?.length})
                </NavLink>
              ) : (
                <Link to="/dashboard/find-roundtrip/create">
                  Add Roundtrip Request
                </Link>
              )}
            </SubMenu>
            <Switch>
              {OFFERS &&
                OFFERS[1]?.roundtrips &&
                OFFERS[1]?.roundtrips?.length > 0 && (
                  <Route
                    path="/dashboard/my-offers/roundtrips"
                    render={() => (
                      <Roundtrips
                        isRegular={isRegular}
                        isExpired={isExpired}
                        expiredModal={expiredModal}
                        setExpiredModal={setExpiredModal}
                        regularModal={regularModal}
                        setRegularModal={setRegularModal}
                        OFFERS={OFFERS}
                        handleStatusChange={handleStatusChange}
                        handleOfferRemove={handleOfferRemove}
                      />
                    )}
                  />
                )}
              {OFFERS &&
                OFFERS[4]?.findRoundtrips &&
                OFFERS[4]?.findRoundtrips?.length > 0 && (
                  <Route
                    exact
                    path="/dashboard/my-offers/find-roundtrip"
                    render={() => (
                      <FindRoundtrips
                        isRegular={isRegular}
                        isExpired={isExpired}
                        expiredModal={expiredModal}
                        setExpiredModal={setExpiredModal}
                        regularModal={regularModal}
                        setRegularModal={setRegularModal}
                        OFFERS={OFFERS}
                        handleStatusChange={handleStatusChange}
                        handleOfferRemove={handleOfferRemove}
                      />
                    )}
                  />
                )}
            </Switch>
          </>
        ) : (
          <Loader />
        )}
        {isBrowser && <Minimessages />}
        <LeftDrawer />
        <DashboardFooter />
      </Screen>
      {expiredModal && (
        <SubscribeGateway 
          onClose={() => {
            setExpiredModal(false);
            setIsActivationModal(false);
          }} 
        />
      )}
      {regularModal && (
        <ProGateway 
          onClose={() => {
            setRegularModal(false);
            setIsActivationModal(false);
          }}
          isActivation={isActivationModal}
        />
      )}
    </>
  );
};

export default MyOffersWrapper;
